import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Grid } from '@mui/material';
import { ThemedTypography } from 'components/common/CommonStyles';

export const ContractListItemComponentSummary = ({ t, contractLite }) => {
  return (
    <Grid item flexGrow={1} display='flex' justifyContent='space-between'>
      <Grid item>
        <strong>{t('RestructuringEdit.ContractList.Summary.Number')}:</strong>{' '}
        <ThemedTypography variant='button' fontSize='16px'>
          {contractLite.contractNumber}
        </ThemedTypography>
      </Grid>
      <Grid item>
        <strong>{t('RestructuringEdit.ContractList.Summary.FinancedValue')}:</strong>{' '}
        <ThemedTypography variant='button' fontSize='16px' color='info'>
          {contractLite.financedValue ? t('NUMBER', { number: contractLite.financedValue }) : ''} {contractLite.currencyCode}
        </ThemedTypography>
      </Grid>
      <Grid item>
        <strong>{t('RestructuringEdit.ContractList.Summary.ContractDate')}:</strong>{' '}
        <ThemedTypography variant='button' fontSize='16px'>
          {contractLite.contractDate}
        </ThemedTypography>
      </Grid>
    </Grid>
  );
};

ContractListItemComponentSummary.propTypes = {
  t: PropTypes.func.isRequired,
  contractLite: PropTypes.object.isRequired
};

export default compose(withTranslation())(ContractListItemComponentSummary);
